import { render } from "./Kodovi.vue?vue&type=template&id=6411744c&scoped=true"
import script from "./Kodovi.vue?vue&type=script&lang=js"
export * from "./Kodovi.vue?vue&type=script&lang=js"

import "./Kodovi.vue?vue&type=style&index=0&id=6411744c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6411744c"]])

export default __exports__